// extracted by mini-css-extract-plugin
module.exports = {"dialog":"PlanHistoryModal_dialog__2QgBa"};